module.exports = __webpack_public_path__ + "img/specials-multislider-6040--mitsubishi.54869186.jpeg";